
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-cloud-snow",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-cloud-snow"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25M8 16h0M8 20h0M12 18h0M12 22h0M16 16h0M16 20h0"}})])
          )
        }
      }
    